import { Box, Button, Checkbox, Chip, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, InputBase } from "@material-ui/core";
import { set } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import useStyles from "src/app/maintenance/assets/styles";
import { DownArrowIcon, UpArrow } from "src/components/Icons";

export const BatchSelectDropDown = (props) => {
    const classes = useStyles();
    const [isDropDown, setIsDropDown] = useState(false);
    const [isApplying, setIsApplying] = useState(false);
    const dropdownRef = useRef(null);
    const [localSelectedBatches, setLocalSelectedBatches] = useState(props.selectedBatches || []);

    useEffect(() => {
        setLocalSelectedBatches(props.selectedBatches || []);
        if (JSON.stringify(props.selectedBatches) !== JSON.stringify(localSelectedBatches)) {
            setIsApplying(false);
        } 
    }, [props.selectedBatches]);
   

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropDown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleBatch = (batch) => {
        if (localSelectedBatches.includes(batch)) {
            setLocalSelectedBatches(localSelectedBatches.filter((b) => b !== batch));
        } else {
            setLocalSelectedBatches([...localSelectedBatches, batch]);
        }
        setIsApplying(false);
    };

    const removeBatch = (batch) => {
        setLocalSelectedBatches(localSelectedBatches.filter((b) => b !== batch));
        setIsApplying(false);
    };

    const handleApply = async () => {
        setIsApplying(true);
        try {
            await props.handleSelectBatchNumber([...localSelectedBatches]);
            setIsDropDown(false);
        } catch (error) {
            console.error("Error applying batch selection:", error);
        }
    };

    return (
        <Grid ref={dropdownRef} container style={{ position: 'relative', width: '100%' }}>
            <div style={{ width: '100%', position: 'relative' }}>
                <div className={classes.batchDropContainer}>
                    <div className={classes.chipsContainer}>
                        {localSelectedBatches.map((batch) => (
                            <Chip
                                key={batch}
                                label={batch}
                                onDelete={() => removeBatch(batch)}
                                size="small"
                                className={classes.batchChip}
                            />
                        ))}
                    </div>
                    <div className={classes.controlsContainer}>
                        {localSelectedBatches.length > 0 && (
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={handleApply}
                                className={classes.applyButton}
                                disabled={isApplying}
                            >
                                Apply
                            </Button>
                        )}
                        <IconButton
                            onClick={() => setIsDropDown(!isDropDown)}
                            size="small"
                        >
                            {isDropDown ? <UpArrow /> : <DownArrowIcon />}
                        </IconButton>
                    </div>
                </div>
                {isDropDown && (
                    <div
                        className={classes.dropdown}
                    >
                        {props.batchNumbers.map((batch, index) => (
                            <Grid key={`${batch}-${index}`} className={classes.countryCodeOption}>
                                <FormGroup style={{ margin: "0px" }}>
                                    <FormControlLabel
                                        label={batch}
                                        control={
                                            <Checkbox
                                                className={classes.radio}
                                                checked={localSelectedBatches.includes(batch)}
                                                onChange={() => toggleBatch(batch)}
                                                color="primary"
                                            />
                                        }
                                    />
                                </FormGroup>
                            </Grid>
                        ))}
                    </div>
                )}
            </div>
        </Grid>
    )
}